<template lang="pug">
b-modal#updateProfileSetting2(
  ref="updateProfileSetting2"
  :title="$t('ui.combine.update_profile_setting')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    //- b-form-group(:label="$tc('ui.key', 1)" disabled).mb-0
    //-   DebounceInput(
    //-     size="sm"
    //-     ref="setting_key"
    //-     required
    //-     alphaNum
    //-     type="text"
    //-     :dirty="$v.setting_key.$dirty"
    //-     :error="$v.setting_key.$error"
    //-     v-model.trim.lazy="$v.setting_key.$model"
    //-     :disabled="loading"
    //-   )
    //-   ValidateResult(:value="$v.setting_key" :name="$t('ui.key')")
    //- b-form-group(:label="$tc('ui.value', 1)").mb-0
    b-form-group(:label="$t('ui.' + setting_key_display)").mb-0
      template(v-if="setting_key == 'bank'")
        b-form-select(
          v-model="setting_value"
          size="sm"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          )
          option(value="COMPANY") {{ $t('ui.company') }}
          option(value="OWN") {{ $t('ui.own') }}
      template(v-else-if="setting_key == 'currency'")
        DebounceInput(
          size="sm"
          ref="setting_value"
          required
          alphaNum
          type="text"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          v-model.trim.lazy="$v.setting_value.$model"
          :disabled="loading"
        )
      template(v-else-if="setting_key == 'access_control'")
        AutoAssignAccessControl(
          size="sm"
          ref="setting_value"
          type="text"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          v-model.trim.lazy="$v.setting_value.$model"
          :disabled="loading"
        )
      template(v-else-if="setting_key == 'tp_site'")
        DebounceInput(
          size="sm"
          ref="setting_value"
          required
          type="text"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          v-model.trim.lazy="$v.setting_value.$model"
          :disabled="loading"
        )
      template(v-else)
        TurnoverRebate(
          size="sm"
          ref="setting_value"
          type="text"
          :dirty="$v.setting_value.$dirty"
          :error="$v.setting_value.$error"
          v-model.trim.lazy="$v.setting_value.$model"
          :disabled="loading"
        )
      ValidateResult(:value="$v.setting_value" :name="$tc('ui.value', 1)")
    template(v-if="setting_key != 'turnover_rebate' && setting_key != 'tp_site'")
      b-form-group(:label="$tc('ui.remark', 1)").mb-0
        DebounceInput(
          size="sm"
          ref="remark"
          type="text"
          :dirty="$v.remark.$dirty"
          :error="$v.remark.$error"
          v-model.trim.lazy="$v.remark.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    //- template(v-else)
    //-   b-form-group(:label="$t('ui.campaign_id')").mb-0
    //-     CampaignLookup(
    //-       size="sm"
    //-       ref="campaign_id"
    //-       required
    //-       type="array"
    //-       :dirty="$v.campaign_id.$dirty"
    //-       :error="$v.campaign_id.$error"
    //-       v-model.trim.lazy="$v.campaign_id.$model"
    //-       :disabled="loading"
    //-     )
    //-     ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import TurnoverRebate from "@/library/TurnoverRebate";
import AutoAssignAccessControl from "@/library/AutoAssignAccessControl";
// import CampaignLookup from "@/library/CampaignLookup";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    TurnoverRebate,
    AutoAssignAccessControl
    // CampaignLookup
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      setting_key: "",
      setting_key_display: "",
      setting_value: "",
      remark: "",
      campaign_id: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  validations: {
    setting_key: {
      required
    },
    setting_value: {
      required
    },
    remark: {
      maxLength: maxLength(20)
    },
    campaign_id: {

    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.globalSettingUpdate2Url();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          setting_key: this.item.setting_key,
          setting_value: this.setting_value,
          // remark: this.setting_key == 'turnover_rebate' ? this.campaign_id : this.remark,
          // remark: this.remark,
        };

        if(this.setting_key != 'tp_site') {
          json.remark = this.remark
        }

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updateProfileSetting2.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "update_profile_setting", this.feedback.status);
                  this.$refs.updateProfileSetting2.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      // console.log(this.item)
      this.$v.$reset();
      this.setting_key = this.item.setting_key;
      this.setting_value = this.item.setting_value;
      this.remark = this.item.remark
      this.campaign_id = this.item.remark
      this.setting_key_display = this.setting_key
      if(this.item.setting_key == 'turnover_rebate') {
        this.remark = ''
      }
      this.$refs.setting_value.$el.focus();
    }
  }
};
</script>
